module.exports = __webpack_public_path__ + "static/img/6.e0633a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/sp/6.png
// module id = LKUD
// module chunks = 0